import React, { useState, useCallback } from "react";
import {
  TextField,
  MenuItem,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Autocomplete,
  Button,
  Box,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import axios from "axios";
import debounce from "lodash/debounce";
import { API_URL } from "../../utils/apiUtils";
import { useFormik } from "formik";
import * as Yup from "yup";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  fetchFullPigmyGroupCollectionByIdService,
  updateGroupCollectionsService,
  updateGroupPigmyCollectionsService,
} from "../../services/groupService";

function GroupPigmyCollection() {
  const date = new Date().toISOString().split("T")[0];
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [groupCollection, setGroupCollection] = useState();

  const [pigmys, setPigmys] = useState([]);
  const token = sessionStorage.getItem("accessToken");

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedData, setSelectedData] = useState([]);

  const handleCheckboxChange = (userId, setFieldValue, collectionAmount) => {
    // setSelectedUsers(
    //   (prevSelected) =>
    //     prevSelected.includes(userId?._id)
    //       ? prevSelected.filter((id) => id !== userId?._id) // Remove if already selected
    //       : [...prevSelected, userId?._id] // Add if not selected
    // );
    const isSelected = selectedUsers.includes(userId?._id);
    const newSelectedUsers = isSelected
      ? selectedUsers.filter((id) => id !== userId?._id)
      : [...selectedUsers, userId?._id];

    setSelectedUsers(newSelectedUsers);

    // setSelectedData((prevData) => {
    //   const existingIndex = prevData.findIndex(
    //     (item) => item._id === userId?._id
    //   );

    //   if (existingIndex !== -1) {
    //     // If the item exists, remove it
    //     return prevData.filter((item) => item._id !== userId);
    //   } else {
    //     // If the item does not exist, add it
    //     return [...prevData, { _id: userId?._id, amount: collectionAmount }];
    //   }
    // });

    const newSelectedData = isSelected
      ? selectedData.filter((item) => item._id !== userId?._id)
      : [...selectedData, { _id: userId?._id, amount: collectionAmount }];

    setSelectedData(newSelectedData);
    console.log(newSelectedData);

    selectedUsers.includes(userId?._id)
      ? console.log(selectedUsers.length - 1)
      : console.log(selectedUsers.length + 1);
   
   
    return newSelectedUsers?.reduce((total, userId) => {
      const userData = newSelectedData.find((item) => item._id === userId);
      return total + (userData ? userData.amount : 0);
    }, 0);
  };

  const calculateTotalAmount = (updatedData) => {
    return selectedUsers?.reduce((total, userId) => {
      const userData = updatedData.find((item) => item._id === userId);
      return total + (userData ? userData.amount : 0);
    }, 0);
  };

  console.log("slsl", selectedData);
  // Handle "Select All" checkbox change
  const handleSelectAllChange = (event) => {
    if (event.target.checked) {
      // Select all users
      const allUserIds = pigmys
        ?.map((pigmy) => pigmy.user?._id)
        .filter(Boolean); // Ensure valid IDs
      setSelectedUsers(allUserIds);
      setSelectedData(
        pigmys.map((pigmy) => ({
          _id: pigmy.user?._id,
          amount: pigmy.collectionAmount,
        }))
      );
    } else {
      // Deselect all users
      setSelectedUsers([]);
      setSelectedData([]);
    }
  };

  // Determine if all users are selected
  const allSelected =
    pigmys.every((pigmy) => selectedUsers.includes(pigmy.user?._id)) &&
    pigmys.length > 0;

  const fetchOptions = async (query) => {
    if (!query) return;
    setLoading(true);
    try {
      const response = await axios.get(
        `${API_URL}/group/search-group-collection`,
        {
          params: { searchQuery: query },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setOptions(response.data.groups);
    } catch (error) {
      console.error("Error fetching options:", error);
    }
    setLoading(false);
  };

  const debouncedFetchOptions = useCallback(
    debounce((query) => {
      fetchOptions(query);
    }, 300),
    []
  );
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, "0"); // Ensure 2 digits
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleAutocompleteChange = async (event, newValue, setFieldValue) => {
    setFieldValue("pigmy", newValue ? newValue._id : "");
    const fetchLoan = await fetchFullPigmyGroupCollectionByIdService(
      newValue._id
    );
    setGroupCollection(fetchLoan?.groupCollection);
    setPigmys(fetchLoan?.pigmys);
    const formattedDueDate = formatDate(fetchLoan?.groupCollection?.dueDate);
    if (fetchLoan.status === "partial") {
      const amount =
        fetchLoan?.groupCollection?.collectionAmount -
        fetchLoan?.groupCollection?.paidAmount;
      setFieldValue("collectionAmount", amount);
      setFieldValue("paidAmount", amount);
    } else {
      setFieldValue(
        "collectionAmount",
        fetchLoan?.groupCollection?.collectionAmount.toFixed(2)
      );
      setFieldValue(
        "paidAmount",
        fetchLoan?.groupCollection?.collectionAmount.toFixed(2)
      );
    }

    console.log(formattedDueDate); // Ensure it's formatted properly
    setFieldValue("frequency", fetchLoan?.groupCollection?.groupId?.frequency);

    setFieldValue("agentName", fetchLoan?.groupCollection?.agent?.userName);

    setFieldValue("dueDate", formattedDueDate);
  };

  const formik = useFormik({
    initialValues: {
      pigmy: "",
      agentName: "",
      frequency: "",
      collectionAmount: "",
      interestAmount: "",
      dueDate: null,
      collectionDate: date,
      paidAmount: 0,
    },
    validationSchema: Yup.object({
      pigmy: Yup.string().required("Loan is required"),
      collectionAmount: Yup.number().required("Collection amount is required"),
      collectionDate: Yup.date().required("CollectionDate Required"),
    }),
    onSubmit: async (values) => {
      try {
        if (selectedUsers.length === 0) {
          toast.error("Select One Colletion");
        } else {
          const updateLoanCollection = await updateGroupPigmyCollectionsService(
            groupCollection?._id,

            values.collectionDate,

            values.paidAmount,
            selectedUsers,
            selectedData
          );
          toast.success("Pigmy collected successfully");
          navigate("/group");
          console.log("userssss", selectedData);
        }
      } catch (error) {
        toast.error(error.message);
      }
    },
  });

  //   const handleAmountPaid = async (value) => {
  //     if (value === "interest") {
  //       return formik?.values?.interestAmount || 0;
  //     } else if (value === "interest+emi" || value === "emi") {
  //       return formik?.values?.collectionAmount;
  //     } else if (value === "penalty") {
  //       return loan?.penaltyAmount;
  //     }
  //   };

  return (
    <Paper sx={{ padding: 4 }}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2}>
          {/* Customer and Loan details section */}
          <Grid item xs={12} sm={12}>
            <Typography variant="body1" gutterBottom>
              Customer Name/Loan Code/Phone Number
            </Typography>
            <Autocomplete
              value={
                options?.find(
                  (option) => option?._id === formik.values.pigmy
                ) || null
              }
              onChange={(event, newValue) => {
                handleAutocompleteChange(event, newValue, formik.setFieldValue);
              }}
              onInputChange={(event, newInputValue) => {
                if (event && event.type === "change") {
                  debouncedFetchOptions(newInputValue);
                }
              }}
              options={options}
              getOptionLabel={(option) =>
                `${option?.groupName} (${option?.groupCode}) ` || ""
              }
              loading={loading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  error={Boolean(formik.touched.pigmy && formik.errors.pigmy)}
                  helperText={formik.touched.pigmy && formik.errors.pigmy}
                />
              )}
            />
          </Grid>

          {/* Agent Name */}
          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Agent Name</Typography>
            <TextField
              fullWidth
              name="agentName"
              value={formik.values.agentName}
              onChange={formik.handleChange}
              size="small"
              disabled={true}
            />
          </Grid>

          {/* Frequency */}
          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Frequency</Typography>
            <TextField
              fullWidth
              name="frequency"
              value={formik.values.frequency}
              onChange={formik.handleChange}
              size="small"
              disabled={true}
            />
          </Grid>

          {/* Loan Amount details */}
          {/* <Grid item xs={12} sm={3}>
            <Typography variant="body2">Total Loan Amount</Typography>
            <TextField
              fullWidth
              name="totalLoanAmount"
              value={formik.values.totalLoanAmount}
              onChange={formik.handleChange}
              size="small"
              disabled={true}
            />
          </Grid> */}

          {/* <Grid item xs={12} sm={3}>
            <Typography variant="body2">Total Received Amount</Typography>
            <TextField
              fullWidth
              name="totalReceivedAmount"
              value={formik.values.totalReceivedAmount}
              onChange={formik.handleChange}
              size="small"
              disabled={true}
            />
          </Grid> */}

          {/* <Grid item xs={12} sm={3}>
            <Typography variant="body2">Remaining Amount</Typography>
            <TextField
              fullWidth
              name="remainingAmount"
              value={formik.values.remainingAmount}
              onChange={formik.handleChange}
              size="small"
              disabled={true}
            />
          </Grid> */}

          {/* Collection and Interest Information */}
          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Collection Amount</Typography>
            <TextField
              fullWidth
              name="collectionAmount"
              disabled={true}
              value={formik.values.collectionAmount}
              onChange={formik.handleChange}
              size="small"
              error={Boolean(
                formik.touched.collectionAmount &&
                  formik.errors.collectionAmount
              )}
              helperText={
                formik.touched.collectionAmount &&
                formik.errors.collectionAmount
              }
            />
          </Grid>

          {/* <Grid item xs={12} sm={3}>
            <Typography variant="body2">Interest Amount</Typography>
            <TextField
              fullWidth
              name="interestAmount"
              value={formik.values.interestAmount}
              onChange={formik.handleChange}
              size="small"
              disabled={true}
            />
          </Grid> */}

          {/* <Grid item xs={12} sm={3}>
            <Typography variant="body2">Total Interest Amount Paid</Typography>
            <TextField
              fullWidth
              name="totalInterestPaid"
              value={formik.values.totalInterestPaid}
              onChange={formik.handleChange}
              size="small"
              disabled={true}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Amount To Be Paid By</Typography>
            <TextField
              size="small"
              name="amountToBePaidBy"
              select
              fullWidth
              required
              variant="outlined"
              value={formik.values.amountToBePaidBy}
              onChange={async (e) => {
                formik.handleChange(e); // Make sure formik handles the field change
                // const amount = await handleAmountPaid(e.target.value); // Pass the selected value to handleAmountPaid
                //formik.setFieldValue("paidAmount", amount); // Set the calculated amount
              }}
            >
              {formik.values?.frequency === "monthly"
                ? [
                    <MenuItem key="interest" value="interest">
                      Interest
                    </MenuItem>,
                    <MenuItem key="emi" value="emi">
                      EMI
                    </MenuItem>,
                    <MenuItem key="interest+emi" value="interest+emi">
                      Interest + EMI
                    </MenuItem>,
                  ]
                : [
                    <MenuItem key="emi" value="emi">
                      EMI
                    </MenuItem>,
                    <MenuItem key="penalty" value="penalty">
                      Penalty
                    </MenuItem>,
                  ]}
            </TextField>
          </Grid> */}

          {/* Collection Date Field */}
          {/* Collection Date Field */}
          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Due Date</Typography>
            <TextField
              type="date"
              name="dueDate"
              value={formik.values.dueDate || ""}
              onChange={formik.handleChange}
              fullWidth
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Collection Date</Typography>
            <TextField
              type="date"
              value={formik?.values?.collectionDate || ""}
              onChange={(e) => {
                formik.setFieldValue("collectionDate", e.target.value);
              }}
              fullWidth
              size="small"
              error={
                formik.touched.collectionDate &&
                Boolean(formik.errors.collectionDate)
              }
              helperText={
                formik.touched.collectionDate && formik.errors.collectionDate
              }
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true, // Makes the field read-only
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography variant="body2">Paid Amount</Typography>
            <TextField
              fullWidth
              name="paidAmount"
              value={formik.values.paidAmount}
              onChange={(e) => {
                formik.setFieldValue("paidAmount", e.target.value);
              }}
              size="small"
              error={Boolean(
                formik.touched.paidAmount && formik.errors.paidAmount
              )}
              InputProps={{
                readOnly: true, // Makes the field read-only
              }}
              helperText={formik.touched.paidAmount && formik.errors.paidAmount}
            />
          </Grid>

          {/* Submit Button */}
        </Grid>
        <Box sx={{ p: 3 }}>
          <Typography variant="h5" gutterBottom>
            User Collections
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={allSelected}
                onChange={handleSelectAllChange}
                indeterminate={
                  selectedUsers.length > 0 && !allSelected // Show indeterminate state
                }
              />
            }
            label="Select All"
            sx={{ mb: 2 }}
          />
          <Grid container spacing={3}>
            {pigmys.map((pigmy, index) => (
              <Grid item xs={3} sm={3} md={3} key={pigmy._id}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    p: 2,
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <Typography variant="h6">Collection {index + 1}</Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedUsers.includes(pigmy.user?._id)}
                        onChange={(setFieldValue) => {
                          const amount = handleCheckboxChange(
                            pigmy.user,
                            setFieldValue,
                            pigmy.collectionAmount
                          );
                          formik.setFieldValue("paidAmount", amount);
                        }}
                      />
                    }
                    label="Select User"
                  />
                  <TextField
                    value={pigmy.user?.userName}
                    fullWidth
                    size="small"
                    InputProps={{ readOnly: true }}
                  />
                  <TextField
                    value={
                      selectedData?.find((item) => item._id === pigmy.user?._id)
                        ?.amount
                    }
                    onChange={(e) => {
                      const updatedData = selectedData?.map((item) =>
                        item._id === pigmy.user?._id
                          ? {
                              ...item,
                              amount: parseFloat(e.target.value) || 0,
                            }
                          : item
                      );
                      setSelectedData(updatedData);
                      const total = calculateTotalAmount(updatedData);
                      formik.setFieldValue("paidAmount", total);
                    }}
                    fullWidth
                    size="small"
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
          {/* <Typography variant="h6" sx={{ mt: 3 }}>
            Selected Users: {selectedUsers.join(", ")}
          </Typography> */}
        </Box>
        <Grid item xs={12}>
          <Button
            type="submit"
            variant="contained"
            sx={{ borderRadius: "8px" }}
            // onClick={handleSubmit}
          >
            Submit
          </Button>
        </Grid>
      </form>
    </Paper>
  );
}

export default GroupPigmyCollection;
